require('./cmWalletBuy.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');

// @ commons
const CmWizard = require('../../cmWizard/cmWizard');
const WizardStep = require('../../cmWizardStep/cmWizardStep');

// @helpers
const { formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @ components
const CmWalletBuyStep1 = require('../cmWalletBuyStep1/cmWalletBuyStep1');
const CmWalletBuyStep2 = require('../cmWalletBuyStep2/cmWalletBuyStep2');
const CmWalletBuyStep3 = require('../cmWalletBuyStep3/cmWalletBuyStep3');
const CmWalletBuySuccess = require('../cmWalletBuySuccess/cmWalletBuySuccess');
const CmErrorState = require('../../cmErrorState/cmErrorState');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
// @ utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getPublicSiteUrl } = require('core/apiURLBuilder');

// @ constants
const { FIRST_STEP, SECOND_STEP, THIRD_STEP } = require('constants/index');
const {
    CM_BUY_TYPE_MONEY,
    CM_BUY_TYPE_TRANSFER,
    CM_WIZARD_FIRST_STEP,
    CM_WIZARD_THIRD_STEP,
    CM_PROC_BUY_FUND,
    CM_PROC_BUY_FUND_ORDERS_OK,
    CM_PROC_BUY_FUND_ORDERS_NOK,
    CM_PROC_BUY_FUND_MODAL,
    CM_PROC_BUY_FUND_MODAL_CONTINUE,
    CM_PROC_BUY_FUND_MODAL_LEAVE,
    CM_PROC_BUY_FUND_MODAL_CLOSE,
} = require('wealth-cm/constants/constants');
const { HIRE_CM } = require('constants/operationCodesAccounts');

class CmWalletBuy extends React.Component {
    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.renderSuccesfulView = this.renderSuccesfulView.bind(this);
        this.renderValidationErrorView = this.renderValidationErrorView.bind(
            this,
        );
        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleModalContinue = this.handleModalContinue.bind(this);
        this.handleModalLeaveWizard = this.handleModalLeaveWizard.bind(this);
        this.handleGoToDiversifiedInvestments = this.handleGoToDiversifiedInvestments.bind(
            this,
        );
    }

    componentDidMount() {
        const { getBlockedAccounts, immAccounts } = this.props;
        scrollToTop();
        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_CM);
    }

    onCancel() {
        const { immCmWalletBuy } = this.props;
        const liquidityTransfer =
            immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY;
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_FIRST_STEP,
            'isTransferWithMoney',
        ]);
        const confirmFundsFromFundsWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);

        if (
            !liquidityTransfer &&
            isTransferWithMoney &&
            confirmFundsFromFundsWithMoney
        ) {
            this.props.activatePreLeaveModal();
        } else {
            this.handleGoToDiversifiedInvestments();
        }
    }

    handleModalClose() {
        recordLink(CM_PROC_BUY_FUND_MODAL, CM_PROC_BUY_FUND_MODAL_CLOSE);
        this.props.deactivatePreLeaveModal();
    }

    handleModalContinue() {
        recordLink(CM_PROC_BUY_FUND_MODAL, CM_PROC_BUY_FUND_MODAL_CONTINUE);
        this.props.deactivatePreLeaveModal();
    }

    handleModalLeaveWizard() {
        const successful = this.buildOKList();
        const notSuccessful = this.buildNOKList();

        recordLink(
            CM_PROC_BUY_FUND,
            `${CM_PROC_BUY_FUND_ORDERS_OK} ${successful.size}, ${CM_PROC_BUY_FUND_ORDERS_NOK} ${notSuccessful.size}`,
        );
        recordLink(CM_PROC_BUY_FUND_MODAL, CM_PROC_BUY_FUND_MODAL_LEAVE);
        this.handleGoToDiversifiedInvestments();
    }

    handleGoToDiversifiedInvestments() {
        const { immCmWalletBuy } = this.props;
        const publicSiteUrl = getPublicSiteUrl(false);
        const simulationUrl = `${publicSiteUrl}/${immCmWalletBuy.getIn([
            'simulation',
            'returnPath',
        ])}`;
        window.location = simulationUrl;
    }

    buildOKList() {
        const { immCmWalletBuy } = this.props;
        const transferOrderResultOkOutput = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoneyData',
            'portfolioTransferConfirmationOutput',
            'transferOrderResultOkOutput',
        ]);

        return transferOrderResultOkOutput;
    }

    buildNOKList() {
        const { immCmWalletBuy } = this.props;
        const validOrderResultOutputNoK = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoneyData',
            'portfolioOrderValidationOutput',
            'validOrderResultOutputNoK',
        ]);
        const validOrderResultOutputOK = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoneyData',
            'portfolioOrderValidationOutput',
            'validOrderResultOutputOk',
        ]);
        const transferOrderResultKoOutput = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoneyData',
            'portfolioTransferConfirmationOutput',
            'transferOrderResultKoOutput',
        ]);
        const orchestratorKoValidationAndConfirmation = validOrderResultOutputNoK
            .concat(transferOrderResultKoOutput)
            .concat(validOrderResultOutputOK);

        return orchestratorKoValidationAndConfirmation;
    }

    buildModal() {
        const { immCmWalletBuy } = this.props;
        const modalHeader = (
            <i className="cm-wallet-buy-step3__modal-custom-icon icon icon-error" />
        );

        return (
            <OKModal
                description="brokerCM-brokerCM_LeaveTransferMoneySubHeader"
                descriptionAlignment="center"
                footerType="action"
                headerContent={modalHeader}
                headerType="custom"
                isOpen={immCmWalletBuy.get('preLeaveModalOpen')}
                onCloseCallback={this.handleModalClose}
                onPrimaryButtonClik={this.handleModalContinue}
                onSecondaryButtonClick={this.handleModalLeaveWizard}
                primaryButtonText="brokerCM-brokerCM_LeaveTransferMoneyContinueButton"
                secondaryButtonText="brokerCM-brokerCM_LeaveTransferMoneyLeaveButton"
                title="brokerCM-brokerCM_LeaveTransferMoneyHeader"
                titleAlignment="center"
            />
        );
    }

    buildWizard() {
        const {
            immCmWalletBuy,
            validateStep,
            setVisibleStep,
            setWillCancel,
            resetStep,
            reportCompleted,
        } = this.props;
        const immSteps = immCmWalletBuy.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immCmWalletBuy.get('visibleStep');
        const wizardClass = 'cm-model-wallet__wizard';
        const portfolioOrderValidationOutputEmpty = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'portfolioOrderValidationOutputEmpty',
        ]);
        const immFinalButton = portfolioOrderValidationOutputEmpty
            ? 'brokerCM-brokerCM_step3ConfirmButtonEmpty'
            : 'brokerCM-brokerCM_step3ConfirmButton';
        const selectionFundsInfo = immCmWalletBuy.getIn([
            'steps',
            FIRST_STEP,
            'selectionFundsInfo',
        ]);
        const buyTypeTransfer =
            immCmWalletBuy.get('buyType') === CM_BUY_TYPE_TRANSFER;
        const isTransferFunds = immCmWalletBuy.getIn([
            'steps',
            FIRST_STEP,
            'isTransferFunds',
        ]);
        const isNextButtonDisabled = immCmWalletBuy.getIn([
            'steps',
            FIRST_STEP,
            'isNextButtonDisabled',
        ]);
        const isTransferWithMoney = immCmWalletBuy.getIn([
            'steps',
            FIRST_STEP,
            'isTransferWithMoney',
        ]);
        const confirmFundsFromFundsWithMoney = immCmWalletBuy.getIn([
            'steps',
            CM_WIZARD_THIRD_STEP,
            'confirmFundsFromFundsWithMoney',
        ]);
        const hasNextButtonText = buyTypeTransfer && isTransferWithMoney;
        const nextButtonText = formatText(
            'brokerCM-brokerCM_step1TransferMoneyNextButton',
        );
        const liquidityTransfer =
            immCmWalletBuy.get('buyType') === CM_BUY_TYPE_MONEY;
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            cancel: this.onCancel,
            resetStep,
        };
        let preLeaveCustomModal;
        if (
            !liquidityTransfer &&
            isTransferWithMoney &&
            confirmFundsFromFundsWithMoney
        ) {
            preLeaveCustomModal = this.buildModal();
        }

        return (
            <div>
                <CmWizard
                    wizardClass={wizardClass}
                    actions={actions}
                    stepsAmount={stepsAmount}
                    visibleStep={visibleStep}
                    immSteps={immSteps}
                >
                    <WizardStep
                        position="first"
                        cancelButton={true}
                        nextButton={true}
                        hasNextButtonText={hasNextButtonText}
                        nextButtonText={nextButtonText}
                        nextButtonDisabled={
                            (buyTypeTransfer &&
                                (!selectionFundsInfo || !isTransferFunds)) ||
                            isNextButtonDisabled
                        }
                        isLoading={immCmWalletBuy.getIn([
                            'steps',
                            FIRST_STEP,
                            'loading',
                        ])}
                    >
                        <CmWalletBuyStep1
                            immCmWalletBuy={this.props.immCmWalletBuy}
                            immAccounts={this.props.immAccounts}
                            onLegalDocumentClick={
                                this.props.onLegalDocumentClick
                            }
                            accountSelected={this.props.accountSelected}
                            onAccountChange={this.props.onAccountChange}
                            setAccount={this.props.setAccount}
                            disableNextButton={this.props.disableNextButton}
                            enableNextButton={this.props.enableNextButton}
                            onSetAmount={this.props.onSetAmount}
                            onSetInitialAmount={this.props.onSetInitialAmount}
                            setIntervenerName={this.props.setIntervenerName}
                            setIntervenerType={this.props.setIntervenerType}
                            addIntervener={this.props.addIntervener}
                            removeIntervener={this.props.removeIntervener}
                            restoreDefaultInterveners={
                                this.props.restoreDefaultInterveners
                            }
                            getPortfolioInfo={this.props.getPortfolioInfo}
                            getContractsAsOriginTransfer={
                                this.props.getContractsAsOriginTransfer
                            }
                            setBuyType={this.props.setBuyType}
                            setOriginFund={this.props.setOriginFund}
                            saveOriginFundInfo={this.props.saveOriginFundInfo}
                            setAccountChanged={this.props.setAccountChanged}
                            flagBasedFeatures={this.props.flagBasedFeatures}
                            fetchFeatureFlag={this.props.fetchFeatureFlag}
                            onFilterAccountChange={
                                this.props.onFilterAccountChange
                            }
                            getPortfolioList={this.props.getPortfolioList}
                            onWalletChange={this.props.onWalletChange}
                            resetOriginFund={this.props.resetOriginFund}
                            saveOriginFundMatchedInPortfolio={
                                this.props.saveOriginFundMatchedInPortfolio
                            }
                        />
                    </WizardStep>
                    <WizardStep
                        position="middle"
                        cancelButton={true}
                        previousButton={true}
                        nextButton={true}
                        isLoading={immCmWalletBuy.getIn([
                            'steps',
                            SECOND_STEP,
                            'loading',
                        ])}
                    >
                        <CmWalletBuyStep2
                            immCmWalletBuy={this.props.immCmWalletBuy}
                            immAccounts={this.props.immAccounts}
                            changeDisclaimerCheck={this.props.validateCheck}
                            onLegalDocumentClick={
                                this.props.onLegalDocumentClick
                            }
                            reportCompleted={reportCompleted}
                        />
                    </WizardStep>
                    <WizardStep
                        position="last"
                        cancelButton={true}
                        previousButton={!isTransferWithMoney}
                        finishButton={true}
                        addLoadingBehaviour={
                            !confirmFundsFromFundsWithMoney ||
                            !portfolioOrderValidationOutputEmpty
                        }
                        finalButtonDisabled={
                            !confirmFundsFromFundsWithMoney &&
                            isTransferWithMoney
                        }
                        immFinalButton={immFinalButton}
                        isLoading={immCmWalletBuy.getIn([
                            'steps',
                            THIRD_STEP,
                            'loading',
                        ])}
                    >
                        <CmWalletBuyStep3
                            actions={actions}
                            visibleStep={visibleStep}
                            immCmWalletBuy={this.props.immCmWalletBuy}
                            changeDisclaimerCheck={
                                this.props.changeDisclaimerCheck
                            }
                            onLegalDocumentClick={
                                this.props.onLegalDocumentClick
                            }
                            runTransferLiquidityOrchestrator={
                                this.props.runTransferLiquidityOrchestrator
                            }
                            onConfirmLeaveTransferMoneyToOtherPage={ // eslint-disable-line
                                this.props
                                    .onConfirmLeaveTransferMoneyToOtherPage
                            }
                            resetConsents={this.props.resetConsents}
                        />
                    </WizardStep>
                </CmWizard>
                {preLeaveCustomModal}
            </div>
        );
    }

    renderSuccesfulView() {
        const {
            immCmWalletBuy,
            immAccounts,
            onLegalDocumentClick,
        } = this.props;

        return (
            <div className="row">
                <div className="col-xs-12 cm-landing__wizard-body-transfer--success">
                    <CmWalletBuySuccess
                        immCmWalletBuy={immCmWalletBuy}
                        immAccounts={immAccounts}
                        onLegalDocumentClick={onLegalDocumentClick}
                    />
                </div>
            </div>
        );
    }

    renderValidationErrorView() {
        const {
            immCmWalletBuy,
            immAccounts,
            onLegalDocumentClick,
        } = this.props;

        return (
            <div className="row">
                <div className="col-xs-12 cm-landing__wizard-body-transfer--error">
                    <CmErrorState
                        immCmWalletBuy={immCmWalletBuy}
                        immAccounts={immAccounts}
                        onLegalDocumentClick={onLegalDocumentClick}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { immCmWalletBuy } = this.props;
        const isFetchingSuccess = immCmWalletBuy.get('isFetchingSuccess');
        const submitSuccessful = immCmWalletBuy.get('submitSuccessful');
        const errorValidation = immCmWalletBuy.get('errorValidation');
        const errorConfirmation = immCmWalletBuy.get('errorConfirmation');

        if (!isFetchingSuccess && submitSuccessful) {
            return this.renderSuccesfulView();
        } else if (errorValidation || errorConfirmation) {
            return this.renderValidationErrorView();
        } else {
            return this.buildWizard();
        }
    }
}

CmWalletBuy.propTypes = {
    immSteps: PropTypes.object,
    changeDisclaimerCheck: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immCmWalletBuy: PropTypes.object.isRequired,
    immCmLegalDocuments: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    onAccountChange: PropTypes.func,
    setAccount: PropTypes.func,
    disableNextButton: PropTypes.func,
    enableNextButton: PropTypes.func,
    fetchLegalDocuments: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    onSetAmount: PropTypes.func,
    onSetInitialAmount: PropTypes.func,
    setIntervenerName: PropTypes.func,
    setIntervenerType: PropTypes.func,
    addIntervener: PropTypes.func,
    removeIntervener: PropTypes.func,
    restoreDefaultInterveners: PropTypes.func,
    accountSelected: PropTypes.string,
    getPortfolioInfo: PropTypes.func,
    getContractsAsOriginTransfer: PropTypes.func,
    portfolioOrderConfirmation: PropTypes.func,
    onLegalDocumentClick: PropTypes.func.isRequired,
    runTransferLiquidityOrchestrator: PropTypes.func,
    setBuyType: PropTypes.func,
    setOriginFund: PropTypes.func,
    saveOriginFundInfo: PropTypes.func,
    setAccountChanged: PropTypes.func,
    onConfirmLeaveTransferMoneyToOtherPage: PropTypes.func,
    resetConsents: PropTypes.func,
    activatePreLeaveModal: PropTypes.func,
    deactivatePreLeaveModal: PropTypes.func,
    flagBasedFeatures: PropTypes.object,
    resetStep: PropTypes.func.isRequired,
    onFilterAccountChange: PropTypes.func,
    getPortfolioList: PropTypes.func,
    onWalletChange: PropTypes.func,
    resetOriginFund: PropTypes.func,
    saveOriginFundMatchedInPortfolio: PropTypes.func,
    reportCompleted: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    validateCheck: PropTypes.func.isRequired,
};

module.exports = CmWalletBuy;
